import React from "react";
import "./searchprint.css";

const SearchAndPrint = ({ setSearchTerm }) => {
  return (
    <div className="search-wrap">
      <label htmlFor="searchInput">Search</label>

      <input
        type="text"
        id="searchInput"
        placeholder="Type to Search"
        onChange={(e) => setSearchTerm(e.target.value)}
      />
    </div>
  );
};

export default SearchAndPrint;